import React from 'react';

import { Box } from '@mui/material';

import { mono, tokens } from '../../theme';

const visuallyHidden = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const;

// Stitch technology chips: small monospace labels on surface-container. With `commas`, hidden
// separators keep the page text a readable list ("A, B, C") for copying and search.
export default function MonoChips({
  items,
  commas = false,
}: {
  items: readonly string[];
  commas?: boolean;
}) {
  return (
    <Box
      component='ul'
      sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexWrap: 'wrap', gap: 1 }}
    >
      {items.map((item, index) => (
        <Box
          component='li'
          key={item}
          sx={{
            position: 'relative',
            fontFamily: mono,
            fontSize: '0.75rem',
            lineHeight: 1.4,
            px: 1,
            py: 0.5,
            borderRadius: 1,
            bgcolor: tokens.surfaceContainer,
            color: tokens.onSurface,
          }}
        >
          {item}
          {commas && index < items.length - 1 && (
            <Box
              component='span'
              sx={visuallyHidden}
            >
              ,{' '}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
